import { useMemo } from 'react'

import useCookie from '@app/hooks/useCookie'
import { METRIC_CARD_TYPE_COOKIE } from '@app/lib/globals'
import AddCardDrawer from '@app/pages/strategies/components/addCards/addCardDrawer'

const AddMetricCardDrawer = () => {
  const [strategyType] = useCookie(METRIC_CARD_TYPE_COOKIE)

  const mutationVariables = useMemo(
    () => ({
      strategyType
    }),
    [strategyType]
  )

  return (
    <AddCardDrawer
      cardType="metric"
      headerText="Metric Cards"
      buttonText="New Metric card"
      mutationVariables={mutationVariables}
    />
  )
}

export default AddMetricCardDrawer
